<template>
    <div
        :class="disabled ? 'cursor-not-allowed opacity-50' : ''"
        class="flex min-h-12 items-center justify-between gap-1 rounded-lg border border-gray-200 px-6 py-1"
    >
        <div v-html="label" />
        <input
            :disabled="disabled"
            :value="value"
            class="w-21.5 [appearance:textfield] border-0 bg-transparent py-1 pr-0 text-right focus:ring-0 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
            min="0"
            placeholder="0"
            tabindex="-1"
            type="number"
            @input="handleInput"
        />
    </div>
</template>
<script setup>
const props = defineProps({
    label: String,
    disabled: Boolean,
    value: { type: Number, default: null },
});

const emit = defineEmits(['change']);

const handleInput = (event) => {
    if (props.disabled) return;
    const raw = event.target.value;
    emit('change', raw === '' ? null : parseInt(raw, 10));
};
</script>
